// Review carousel (sections/review-carousel.liquid). No dependencies.
// Autoplay pauses on hover/focus, has a pause button, and is off for prefers-reduced-motion.
(function () {
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function init(root) {
    if (!root || root.__rc) return;
    var track = root.querySelector('[data-rc-track]');
    var viewport = root.querySelector('[data-rc-viewport]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rc-slide]'));
    var controls = root.querySelector('[data-rc-controls]');
    var prev = root.querySelector('[data-rc-prev]');
    var next = root.querySelector('[data-rc-next]');
    var dotsWrap = root.querySelector('[data-rc-dots]');
    var counter = root.querySelector('[data-rc-count]');
    var toggle = root.querySelector('[data-rc-toggle]');
    if (!track || !slides.length) return;

    var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
    var wantsAutoplay = root.getAttribute('data-autoplay') === 'true' && !!toggle;
    var userPaused = reduce.matches; // reduced motion: start paused, visitor can still press play
    var hoverPause = false, focusPause = false, hiddenPause = false, offscreenPause = false;
    var page = 0, pages = 1, per = 1, timer = null;

    root.__rc = { destroy: destroy };
    root.classList.add('rc--js');
    viewport.scrollLeft = 0;
    if (controls) controls.hidden = false;
    if (slides.length < 2 && controls) controls.hidden = true;

    function perView() {
      var v = parseInt(getComputedStyle(track).getPropertyValue('--rc-per'), 10);
      return v > 0 ? v : 1;
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      var useCounter = pages > 10;
      dotsWrap.hidden = useCounter;
      if (counter) counter.hidden = !useCounter;
      if (useCounter) return;
      for (var i = 0; i < pages; i++) {
        var li = document.createElement('li');
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rc__dot';
        var first = i * per + 1, last = Math.min(slides.length, first + per - 1);
        b.setAttribute('aria-label', per > 1 && last > first ? 'Show reviews ' + first + ' to ' + last : 'Show review ' + first);
        b.setAttribute('data-index', i);
        b.addEventListener('click', function () { go(parseInt(this.getAttribute('data-index'), 10), true); });
        li.appendChild(b);
        dotsWrap.appendChild(li);
      }
    }

    function layout() {
      per = Math.min(perView(), slides.length);
      pages = Math.max(1, Math.ceil(slides.length / per));
      if (page > pages - 1) page = pages - 1;
      buildDots();
      render();
    }

    function offsetFor(p) { return Math.min(p * per, slides.length - per); }

    function render(dragPx) {
      var off = offsetFor(page);
      var pct = -(off * 100 / per);
      track.style.transform = 'translateX(calc(' + pct + '% + ' + (dragPx || 0) + 'px))';
      slides.forEach(function (s, i) {
        var visible = i >= off && i < off + per;
        if (visible) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      Array.prototype.forEach.call(dotsWrap.querySelectorAll('.rc__dot'), function (d, i) {
        if (i === page) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      if (counter) {
        counter.textContent = (off + 1) + (per > 1 ? '–' + (off + per) : '') + ' / ' + slides.length;
      }
    }

    function go(p, fromUser) {
      page = (p + pages) % pages;
      if (fromUser) track.setAttribute('aria-live', 'polite');
      render();
      if (fromUser) restart();
    }

    function playing() {
      return wantsAutoplay && !userPaused && !hoverPause && !focusPause && !hiddenPause && !offscreenPause && pages > 1;
    }

    function restart() {
      clearInterval(timer); timer = null;
      if (playing()) {
        track.setAttribute('aria-live', 'off');
        timer = setInterval(function () { go(page + 1, false); }, interval);
      } else {
        track.setAttribute('aria-live', 'polite');
      }
    }

    function syncToggle() {
      if (!toggle) return;
      toggle.setAttribute('data-state', userPaused ? 'paused' : 'playing');
      toggle.setAttribute('aria-label', userPaused ? toggle.getAttribute('data-label-play') : toggle.getAttribute('data-label-pause'));
    }

    if (toggle) toggle.addEventListener('click', function () { userPaused = !userPaused; syncToggle(); restart(); });
    prev.addEventListener('click', function () { go(page - 1, true); });
    next.addEventListener('click', function () { go(page + 1, true); });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(page - 1, true); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { go(page + 1, true); e.preventDefault(); }
    });
    root.addEventListener('mouseenter', function () { hoverPause = true; restart(); });
    root.addEventListener('mouseleave', function () { hoverPause = false; restart(); });
    root.addEventListener('focusin', function () { focusPause = true; restart(); });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focusPause = false; restart(); } });
    function onVis() { hiddenPause = document.hidden; restart(); }
    document.addEventListener('visibilitychange', onVis);
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) { offscreenPause = !entries[0].isIntersecting; restart(); });
      io.observe(root);
    }

    // Swipe (touch/pen). Mouse users keep normal text selection and use the buttons.
    var startX = null, startY = null, dx = 0, swiping = false;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      startX = e.clientX; startY = e.clientY; dx = 0; swiping = false;
    });
    viewport.addEventListener('pointermove', function (e) {
      if (startX === null) return;
      dx = e.clientX - startX;
      if (!swiping && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(e.clientY - startY)) {
        swiping = true; root.classList.add('rc--dragging');
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (swiping) render(dx);
    });
    function endSwipe() {
      if (startX === null) return;
      root.classList.remove('rc--dragging');
      if (swiping && Math.abs(dx) > Math.min(60, viewport.clientWidth * 0.15)) go(page + (dx < 0 ? 1 : -1), true);
      else render();
      startX = null; swiping = false; dx = 0;
    }
    viewport.addEventListener('pointerup', endSwipe);
    viewport.addEventListener('pointercancel', endSwipe);

    var rt;
    function onResize() { clearTimeout(rt); rt = setTimeout(function () { if (perView() !== per) layout(); }, 150); }
    window.addEventListener('resize', onResize);
    function onMotion() { if (reduce.matches) { userPaused = true; syncToggle(); restart(); } }
    if (reduce.addEventListener) reduce.addEventListener('change', onMotion);

    function destroy() {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('resize', onResize);
      if (reduce.removeEventListener) reduce.removeEventListener('change', onMotion);
      if (io) io.disconnect();
      root.__rc = null;
    }

    root.__rc.select = function (el) {
      var i = slides.indexOf(el);
      if (i < 0) return;
      userPaused = true; syncToggle();
      go(Math.floor(i / per), true);
      if (offsetFor(page) > i) page = Math.floor(i / per);
    };

    syncToggle();
    layout();
    restart();
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-review-carousel]'), init);
  }
  initAll();

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-review-carousel]'), function (r) { if (r.__rc) r.__rc.destroy(); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest && e.target.closest('[data-review-carousel]');
    if (root && root.__rc && root.__rc.select) root.__rc.select(e.target);
  });
})();
